// Client logos sourced from ragimedia.com client portfolio.
export const clientLogos = [
    { name: "Bosch", file: "bosch" },
    { name: "Biocon", file: "biocon" },
    { name: "Swiggy", file: "swiggy" },
    { name: "Nykaa", file: "nykaa" },
    { name: "Toyota Tsusho", file: "toyota-tsusho" },
    { name: "Adecco", file: "adecco" },
    { name: "Cothas Coffee", file: "cothas-coffee" },
    { name: "Widex", file: "widex" },
    { name: "OPEN", file: "open" },
    { name: "Royaloak", file: "royaloak" },
    { name: "Nature's Basket", file: "natures-basket" },
    { name: "Kuku FM", file: "kuku-fm" },
    { name: "Emma Sleep", file: "emma-sleep" },
    { name: "Kalpataru", file: "kalpataru" },
    { name: "SuperK", file: "superk" },
    { name: "Elev8", file: "elev8" },
    { name: "Thriveni", file: "thriveni" },
    { name: "Right Parking", file: "right-parking" },
    { name: "Eletus", file: "eletus" },
    { name: "SR Daily Nutrition", file: "sr-daily-nutrition" },
];
